import { DateTime } from "luxon";

const getUnixTime = (date: any) => {
  const localDateTime = DateTime.fromJSDate(new Date(date), {
    zone: "Asia/Kolkata",
  });
  const localISOString = localDateTime.toISO();
  return DateTime.fromISO(localISOString, {
    zone: "asia/kolkata",
  }).toMillis();
};

export { getUnixTime };
